"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAffordabilityInputs = void 0;
var MortgageCommonState_init_1 = require("@/pages/mortagage/states/MortgageCommonState.init");
exports.toAffordabilityInputs = function (state) {
    var mortgage = MortgageCommonState_init_1.defaultMortgageCommonState;
    var affordabilityInputs = {
        hasOutstandingMortgage: false,
        monthlyPayment: state.calcMonthlyValue,
        downPayment: state.calcDownpayValue,
        tenor: state.calcTenorValue,
        interestRate: state.calcRateValue,
        buyerStampDuty: false,
        adValoremStampDuty: false,
        lastTransactionInMonth: 0,
        commissionRate: mortgage.commissionRate,
        buyerStampDutyRate: mortgage.buyerStampDutyRate,
        adValoremStampDutyRate: mortgage.adValoremStampDutyRate,
        specialStampDutyRateTable: mortgage.specialStampDutyRateTable,
        doubleAdValoremStampDutyRateTable: mortgage.doubleAdValoremStampDutyRateTable,
        mortgagePlanList: state.calcMortgagePlans,
        mortgagePlanListWithProperty: mortgage.mortgageInsuranceSettingWithProperty,
        mortgageLimitTable: state.calcMortgageLimits,
        isInsuranceMonthlyRepay: true,
        legalAmount: state.calcLegalAmount,
        rateTableInputs: state.calcRateTableInputs,
    };
    return affordabilityInputs;
};
